import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'

import { Table } from "reactstrap";

const mapStateToProps = (state) => {

    return {
        getAlumnoDetail: state.AlumnoReducer.getAlumnoDetail,
    };
    
}; //END MAPSTATETOPROPS

class AlumnoDelete extends Component {


    render() {
        let isEmpty  = this.props.getAlumnoDetail.length === 0;
        let alumno    = Object.values(this.props.getAlumnoDetail);

        return (
            <form onSubmit={this.props.handleSubmit}>
                <FormGroup row>
                    <Col md="12">
                        <FormGroup>

                            <Table striped>
                                <tbody>


                                    {isEmpty ?
                                        <div>There are no results</div>
                                        :
                                        alumno.map(item =>

                                            <>

                                                <tr>
                                                    <td width="200">ID Alumno</td>
                                                    <td width="10">:</td>
                                                    <td>{item.idalumno}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">ID Tutor</td>
                                                    <td width="10">:</td>
                                                    <td>{item.idtutor}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Apellido Paterno</td>
                                                    <td width="10">:</td>
                                                    <td>{item.apellidopaterno}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Apellido Materno</td>
                                                    <td width="10">:</td>
                                                    <td>{item.apellidomaterno}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Nombres</td>
                                                    <td width="10">:</td>
                                                    <td>{item.nombres}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Sexo</td>
                                                    <td width="10">:</td>
                                                    <td>{item.sexo}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Fecha Nacimiento</td>
                                                    <td width="10">:</td>
                                                    <td>{item.fechanacimiento}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Estado NacimientoD</td>
                                                    <td width="10">:</td>
                                                    <td>{item.estadonacimiento}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Discapacidad</td>
                                                    <td width="10">:</td>
                                                    <td>{item.discapacidad}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">discapacidaddescripcion</td>
                                                    <td width="10">:</td>
                                                    <td>{item.discapacidaddescripcion}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Otra</td>
                                                    <td width="10">:</td>
                                                    <td>{item.otra}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Aptitud</td>
                                                    <td width="10">:</td>
                                                    <td>{item.aptitud}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Aptitud Descripcion</td>
                                                    <td width="10">:</td>
                                                    <td>{item.aptituddescripcion}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Calle</td>
                                                    <td width="10">:</td>
                                                    <td>{item.calle}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Número</td>
                                                    <td width="10">:</td>
                                                    <td>{item.numero}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Colonia</td>
                                                    <td width="10">:</td>
                                                    <td>{item.colonia}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Municipio</td>
                                                    <td width="10">:</td>
                                                    <td>{item.municipio}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Código Postal</td>
                                                    <td width="10">:</td>
                                                    <td>{item.codigopostal}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Teléfono</td>
                                                    <td width="10">:</td>
                                                    <td>{item.telefono}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Nivel</td>
                                                    <td width="10">:</td>
                                                    <td>{item.nivel}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Grado</td>
                                                    <td width="10">:</td>
                                                    <td>{item.nivel2}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Grupo</td>
                                                    <td width="10">:</td>
                                                    <td>{item.grupo}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Turno</td>
                                                    <td width="10">:</td>
                                                    <td>{item.turno}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Baja</td>
                                                    <td width="10">:</td>
                                                    <td>{(item.baja == true) ? "SI" : "NO"}</td>
                                                </tr>

                                            </>

                                        )
                                    }

                                </tbody>
                            </Table>


                        </FormGroup>
                    </Col>
                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

AlumnoDelete = reduxForm({
    form: "formAlumnoDelete",
    enableReinitialize: true,
})(AlumnoDelete);
export default connect(mapStateToProps, null)(AlumnoDelete);
